import { cn } from '@simplywallst/ui-core/next';
import WarrenSolid from '@simplywallst/ui-core/icons/WarrenSolid';
import WarrenBearSolid from '@simplywallst/ui-core/icons/WarrenBearSolid';
import { pluralise } from '@/utilities/pluralise';
import type { ValuationOption } from '../narrativeOptionFragment';

type Props = {
  type: ValuationOption['type'];
  priceTargetAnalystCount: number | null | undefined;
  owner?: { displayName: string | null };
};

const iconWrapperClasses = cn(
  'grid size-x4 items-center justify-center bg-p-grey-10'
);

export const useNarrativeSyntheticMetadata = ({
  type,
  priceTargetAnalystCount,
  owner,
}: Props) => {
  if (type === 'DCF') {
    return {
      label: 'Discounted Cash Flow',
      subtitle: 'Simply Wall St',
      icon: (
        <div className={iconWrapperClasses}>
          <WarrenSolid className="w-6" />
        </div>
      ),
    };
  }

  const getSubtitle = () => {
    if (!priceTargetAnalystCount) return 'Consensus Narrative from Analysts';

    return `Consensus Narrative from ${priceTargetAnalystCount} ${pluralise(
      priceTargetAnalystCount,
      'Analyst',
      'Analysts'
    )}`;
  };

  const title = owner?.displayName || 'User';

  return {
    label: title,
    subtitle: getSubtitle(),
    icon: (
      <div className={cn(iconWrapperClasses, 'bg-p-white-120')}>
        <WarrenBearSolid className="w-6" />
      </div>
    ),
  };
};
